import axios from "axios";

const instance = axios.create({
  // THE API (cloud function) URL
  baseURL: "http://localhost:5001/ecommerce-website-f0972/us-central1/api",
  // "http://localhost:5001/ecommerce-website-f0972/us-central1/api",
});

export default instance;
